<script>
import { mapGetters } from "vuex";

export default {
  props: {
    filtro: Object,
    label_filtro: String,
    tipoFiltro: {
      type: String,
      default: "codigo",
    },
  },
  emits: ["submit", "limpiar"],
  data() {
    return {
      formFiltro: [],
    };
  },
  methods: {
    borrarFiltro() {
      this.formFiltro = [];
      this.$emit('limpiar');
    },
    changeValue(id, campo) {
      this.formFiltro = [{ id: id, type: this.tipoFiltro, value: campo }];
    },
  },
};
</script>

<template>
  <form
    class="flex flex-col gap-4"
    @submit.prevent="$emit('submit', formFiltro)"
  >
  
    <div class="flex flex-col text-left">
      <label>{{ label_filtro ?? "" }}</label>
      <input
        type="text"
        @change="(event) => changeValue(filtro.id, event.target?.value)"
        required
      />
    </div>

    <div class="flex flex-row justify-end items-center gap-2">
      <button type="submit" class="btn-principal">Filtrar</button>

      <button
        type="button"
        @click="borrarFiltro"
        class="btn-secundario btn-small"
      >
        Limpiar
      </button>
    </div>
  </form>
</template>
